import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import Lottie from 'lottie-react';
import React from 'react';
import { hero as lottieHero } from '../result/lottie/Hero';

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      width: 900,
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      marginTop: 13,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 53,
    },
  },
  image: {
    zIndex: 4,
    marginLeft: '-15px',
    [theme.breakpoints.down('md')]: {
      alignSelf: 'center',
    },
    [theme.breakpoints.up('md')]: {
      alignSelf: 'stretch',
    },
  },
  header: {
    color: '#202124',
    marginTop: 10,
    fontWeight: 500,
    marginBottom: 18,
    [theme.breakpoints.down('md')]: {
      fontSize: '36px',
      lineHeight: '40px',
      letterSpacing: '-0.25px',
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '72px',
      lineHeight: '77px',
      letterSpacing: '-0.31px',
      textAlign: 'left',
    },
  },
  left: {
    alignSelf: 'stretch',
    fontSize: '18px',
    lineHeight: '30px',
    letterSpacing: '0.2px',
    zIndex: 4,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 20,
      paddingRight: 20,
      textAlign: 'center',
      marginBottom: 40,
    },
    '& small': {
      fontSize: '10px',
      color: 'rgb(95, 99, 104);',
      "& a:-webkit-any-link  ":{
        color:'rgb(95, 99, 104);'
    },
    },
    '& b': {
      fontWeight: 500,
      [theme.breakpoints.down('md')]: {
        fontWeight: 700,
      },
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 20,
      padding: 0,
      textAlign: 'left',
      marginRight: 60,
    },
  },
  headerPicture: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  hero: {
    alignSelf: 'center',
    [theme.breakpoints.down('md')]: {
      width: 200,
    },
    [theme.breakpoints.up('md')]: {
      width: 320,
      marginTop:120,
    },
  },
}));

const TextDesktop = () => (
  <>
    <p>
      Over half of businesses worldwide lack end-to-end visibility into their
      supply chains. Data management and insights driven by ML and AI can bring
      resiliency and sustainability to your supply chains.
      <br />
    </p>
    <p>
      Take this <b>2-minute assessment</b> to unlock resources and insights to
      help you reach analytics excellence.
    </p>
    <small> Source: <a target="_blank" href="https://www.ascm.org/eiu-benchmark/">Association for Supply Chain Management</a> </small>
  </>
);

const TextMobile = () => (
  <>
    <p>
      Over half of businesses worldwide lack end-to-end visibility into their
      supply chains. Data management and insights driven by ML and AI can bring
      resiliency and sustainability to your supply chains.
      <br />
    </p>
    <p>
      Take this <b>2-minute assessment</b> to unlock resources and insights to
      help you reach analytics excellence.
    </p>
  </>
);

export const Intro = () => {
  const {
    container,
    root,
    left,
    image,
    header,
    headerPicture,
    hero,
  } = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <div className={container}>
      <div className={root}>
        <img
          className={image}
          width="200"
          src={process.env.PUBLIC_URL + '/google_cloud_logo_healthcare.png'}
          alt="google cloud logo"
        />
        <div className={headerPicture}>
          <div style={{ flex: 1 }}>
            <h1 className={header}>
              Which half do <br /> you belong to?
            </h1>
            <div className={left}>
              {matches ? <TextMobile /> : <TextDesktop />}
            </div>
          </div>
          <img
              className={hero}
              
              src={process.env.PUBLIC_URL + '/hero.svg'}
              alt=""
            />
        </div>
      </div>
    </div>
  );
};
